import { all, call, put, takeEvery, takeLatest } from "redux-saga/effects";

import {
  GET_REVIEW_LIST,
  GET_REVIEW_DATA,
  CREATE_REVIEW,
  UPDATE_REVIEW,
  DELETE_REVIEW,
  ASSIGN_REVIEW_CUSTOMER,
  SET_REVIEW_STATUS,
  REPLY_REVIEW,
  GET_REVIEW_PROVIDERS,
  UPDATE_REVIEW_PROVIDER,
  SYNC_REVIEW_GOOGLE,
  GET_REVIEW_STATUS_LIST,
  GET_REVIEW_STATUS_DATA,
  CREATE_REVIEW_STATUS,
  UPDATE_REVIEW_STATUS,
  DELETE_REVIEW_STATUS,
} from "./actionType";

import {
  getReviewListSuccess,
  getReviewListFailure,
  getReviewDataSuccess,
  getReviewDataFailure,
  createReviewSuccess,
  createReviewFailure,
  updateReviewSuccess,
  updateReviewFailure,
  deleteReviewSuccess,
  deleteReviewFailure,
  assignReviewCustomerSuccess,
  assignReviewCustomerFailure,
  setReviewStatusSuccess,
  setReviewStatusFailure,
  replyReviewSuccess,
  replyReviewFailure,
  getReviewProvidersSuccess,
  getReviewProvidersFailure,
  updateReviewProviderSuccess,
  updateReviewProviderFailure,
  syncReviewGoogleSuccess,
  syncReviewGoogleFailure,
  getReviewStatusListSuccess,
  getReviewStatusListFailure,
  getReviewStatusDataSuccess,
  getReviewStatusDataFailure,
  createReviewStatusSuccess,
  createReviewStatusFailure,
  updateReviewStatusSuccess,
  updateReviewStatusFailure,
  deleteReviewStatusSuccess,
  deleteReviewStatusFailure,
} from "./action";

import {
  getReviewListApi,
  getReviewDataApi,
  createReviewApi,
  updateReviewApi,
  deleteReviewApi,
  assignReviewToCustomerApi,
  setReviewStatusApi,
  replyReviewApi,
  getReviewProvidersApi,
  updateReviewProviderApi,
  syncReviewGoogleApi,
  getReviewStatusListApi,
  getReviewStatusDataApi,
  createReviewStatusApi,
  updateReviewStatusApi,
  deleteReviewStatusApi,
} from "../../helpers/fakebackend_helper";

// ---- Reviews ----
function* onGetReviewList() {
  try {
    const response = yield call(getReviewListApi);
    yield put(getReviewListSuccess(response));
  } catch (error) {
    yield put(getReviewListFailure(error));
  }
}

function* onGetReviewData({ payload }) {
  try {
    const response = yield call(getReviewDataApi, payload);
    yield put(getReviewDataSuccess(response));
  } catch (error) {
    yield put(getReviewDataFailure(error));
  }
}

function* onCreateReview({ payload }) {
  try {
    const response = yield call(createReviewApi, payload);
    yield put(createReviewSuccess(response));
  } catch (error) {
    yield put(createReviewFailure(error));
  }
}

function* onUpdateReview({ payload }) {
  try {
    const response = yield call(updateReviewApi, payload);
    yield put(updateReviewSuccess(response));
  } catch (error) {
    yield put(updateReviewFailure(error));
  }
}

function* onDeleteReview({ payload }) {
  try {
    const response = yield call(deleteReviewApi, payload);
    yield put(deleteReviewSuccess(response));
  } catch (error) {
    yield put(deleteReviewFailure(error));
  }
}

function* onAssignReviewCustomer({ payload }) {
  try {
    const response = yield call(assignReviewToCustomerApi, payload);
    yield put(assignReviewCustomerSuccess(response));
  } catch (error) {
    yield put(assignReviewCustomerFailure(error));
  }
}

function* onSetReviewStatus({ payload }) {
  try {
    const response = yield call(setReviewStatusApi, payload);
    yield put(setReviewStatusSuccess(response));
  } catch (error) {
    yield put(setReviewStatusFailure(error));
  }
}

function* onReplyReview({ payload }) {
  try {
    const response = yield call(replyReviewApi, payload);
    yield put(replyReviewSuccess(response));
  } catch (error) {
    yield put(replyReviewFailure(error));
  }
}

// ---- Providers ----
function* onGetReviewProviders() {
  try {
    const response = yield call(getReviewProvidersApi);
    yield put(getReviewProvidersSuccess(response));
  } catch (error) {
    yield put(getReviewProvidersFailure(error));
  }
}

function* onUpdateReviewProvider({ payload }) {
  try {
    const response = yield call(updateReviewProviderApi, payload);
    yield put(updateReviewProviderSuccess(response));
  } catch (error) {
    yield put(updateReviewProviderFailure(error));
  }
}

function* onSyncReviewGoogle() {
  try {
    const response = yield call(syncReviewGoogleApi);
    yield put(syncReviewGoogleSuccess(response));
  } catch (error) {
    yield put(syncReviewGoogleFailure(error));
  }
}

// ---- Status lanes ----
function* onGetReviewStatusList() {
  try {
    const response = yield call(getReviewStatusListApi);
    yield put(getReviewStatusListSuccess(response));
  } catch (error) {
    yield put(getReviewStatusListFailure(error));
  }
}

function* onGetReviewStatusData({ payload }) {
  try {
    const response = yield call(getReviewStatusDataApi, payload);
    yield put(getReviewStatusDataSuccess(response));
  } catch (error) {
    yield put(getReviewStatusDataFailure(error));
  }
}

function* onCreateReviewStatus({ payload }) {
  try {
    const response = yield call(createReviewStatusApi, payload);
    yield put(createReviewStatusSuccess(response));
  } catch (error) {
    yield put(createReviewStatusFailure(error));
  }
}

function* onUpdateReviewStatus({ payload }) {
  try {
    const response = yield call(updateReviewStatusApi, payload);
    yield put(updateReviewStatusSuccess(response));
  } catch (error) {
    yield put(updateReviewStatusFailure(error));
  }
}

function* onDeleteReviewStatus({ payload }) {
  try {
    const response = yield call(deleteReviewStatusApi, payload);
    yield put(deleteReviewStatusSuccess(response));
  } catch (error) {
    yield put(deleteReviewStatusFailure(error));
  }
}

export default function* ReviewsSaga() {
  yield all([
    takeLatest(GET_REVIEW_LIST, onGetReviewList),
    takeEvery(GET_REVIEW_DATA, onGetReviewData),
    takeEvery(CREATE_REVIEW, onCreateReview),
    takeEvery(UPDATE_REVIEW, onUpdateReview),
    takeEvery(DELETE_REVIEW, onDeleteReview),
    takeEvery(ASSIGN_REVIEW_CUSTOMER, onAssignReviewCustomer),
    takeEvery(SET_REVIEW_STATUS, onSetReviewStatus),
    takeEvery(REPLY_REVIEW, onReplyReview),
    takeLatest(GET_REVIEW_PROVIDERS, onGetReviewProviders),
    takeEvery(UPDATE_REVIEW_PROVIDER, onUpdateReviewProvider),
    takeLatest(SYNC_REVIEW_GOOGLE, onSyncReviewGoogle),
    takeLatest(GET_REVIEW_STATUS_LIST, onGetReviewStatusList),
    takeEvery(GET_REVIEW_STATUS_DATA, onGetReviewStatusData),
    takeEvery(CREATE_REVIEW_STATUS, onCreateReviewStatus),
    takeEvery(UPDATE_REVIEW_STATUS, onUpdateReviewStatus),
    takeEvery(DELETE_REVIEW_STATUS, onDeleteReviewStatus),
  ]);
}
